import { Alert } from "@mui/material";

import { useAccountSite } from "@/api/siteDetails";
import { useSiteNavigation } from "@/hooks/useSiteNavigation";

export const EMAIL_SETUP_BANNER_LEAD = "Email setup incomplete.";

export const EMAIL_SETUP_BANNER_DETAIL =
  "From name, From email, sender domain, and DNS verification are required. Finish setup in Email Settings.";

export function EmailSetupBanner() {
  const { siteIdFromParams } = useSiteNavigation();
  const { data: site } = useAccountSite(siteIdFromParams ?? "");

  // Explicit false only: null means the API predates the field, so stay hidden.
  if (!site || site.email_ready !== false) {
    return null;
  }

  // error, not warning: alone among the three banners, this state blocks sending.
  return (
    <Alert
      severity="error"
      data-testid="email-setup-banner"
      sx={{
        borderRadius: 0,
        justifyContent: "center",
        "& .MuiAlert-message": { flex: "unset", textAlign: "center" },
      }}
    >
      <strong>{EMAIL_SETUP_BANNER_LEAD}</strong> {EMAIL_SETUP_BANNER_DETAIL}
    </Alert>
  );
}
